// トップスライダーの起動 // Launch the top slider

if (document.querySelector(".top-swiper")) {
  new Swiper(".top-swiper", {
    speed: 1000, // スライド変化時間
    loop: true,
    loopAdditionalSlides: 1,
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 8,
    autoplay: {
      delay: 4000, //　スライダー表示時間
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

if (document.querySelector(".recommend-swiper")) {
  new Swiper(".recommend-swiper", {
    speed: 800,
    slidesPerView: "auto",
    spaceBetween: 40,
    pagination: {
      el: ".p-front_sec1__pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".p-front_sec1__arrow--next",
      prevEl: ".p-front_sec1__arrow--prev",
    },
    breakpoints: {
      0: {
        spaceBetween: 24,
      },
      769: {
        spaceBetween: 40,
      },
    },
  });
}

jQuery(function($) {
  var $columnSlider = $('.p-frontColumn__list');

  if ($columnSlider.length === 0 || typeof $.fn.slick !== 'function') {
    return;
  }

  function updateColumnSlider() {
    if (window.innerWidth <= 568) {
      if (!$columnSlider.hasClass('slick-initialized')) {
        $columnSlider.slick({
          arrows: false,
          dots: false,
          infinite: false,
          variableWidth: true,
          slidesToShow: 1,
          swipeToSlide: true,
          touchThreshold: 12
        });
      }
      return;
    }

    if ($columnSlider.hasClass('slick-initialized')) {
      $columnSlider.slick('unslick');
    }
  }

  updateColumnSlider();
  $(window).on('resize', updateColumnSlider);
});

document.querySelectorAll('.p-residence-list__imageSwitch').forEach(function(switchButton) {
  function toggleResidenceImage(event) {
    event.preventDefault();
    event.stopPropagation();

    var media = switchButton.closest('.p-residence-list__media');
    if (!media) {
      return;
    }

    var showFloor = !media.classList.contains('is-floor-visible');
    media.classList.toggle('is-floor-visible', showFloor);
    switchButton.setAttribute('aria-pressed', String(showFloor));
    switchButton.setAttribute('aria-label', showFloor ? '物件写真を表示' : '間取り図を表示');
    switchButton.querySelector('span').textContent = showFloor ? '物件写真' : '間取り図';
  }

  switchButton.addEventListener('click', toggleResidenceImage);
  switchButton.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleResidenceImage(event);
    }
  });
});
